

const setToggleButtonClassName = (toggleButton,isEmail) => {        
    if(toggleButton.leftButton !== undefined){
        
        if(isEmail){
            toggleButton.leftButton.classList.remove('jut__ToggleField__active');
            toggleButton.rightButton.classList.add('jut__ToggleField__active');
        }else {
            toggleButton.leftButton.classList.add('jut__ToggleField__active');
            toggleButton.rightButton.classList.remove('jut__ToggleField__active');
        }
    }
};

const getToggleButtonObj = () => {
    let leftButton  = document.querySelector('.jut__ToggleField__left');;
    let rightButton  = document.querySelector('.jut__ToggleField__right');;

    return {
        "leftButton": leftButton,
        "rightButton": rightButton
    };
};

// Only one check button at any time.
const getCheckButton = () => {
    const checkIcon = document.querySelector('.mi-check');  
    if(checkIcon != undefined && checkIcon != null){
        const checkButton = checkIcon.closest('button');
        return checkButton;
    }    
    return null;
};

// Only one "X" button at any time.
const getCloseButton = () => {
    const closeIcom = document.querySelector('.mi-close');  
    
    if(closeIcom != undefined && closeIcom != null){
        const closeButton = closeIcom.closest('button');
        return closeButton;
    }    
    return null;
};

const clickCheckButton = () => {
    if(getCheckButton() != null){
        getCheckButton().click();
    }
};

const getTrashButton = () => {
    const trashIcons = document.querySelectorAll('.fa-trash');  
    let trashButtons = [];
    for (let index = 0; index < trashIcons.length; index++) {
        const trashIcon = trashIcons[index];
        trashButtons.push(trashIcon.closest('button'));
    }
    return trashButtons;
};

// When add a new email address, then cancelled the add,
// click the last trash button to delete it.
const clickLastTrashButton = () =>{
    const trashButtons = getTrashButton();
    trashButtons[trashButtons.length -1].click();
};

const buildEmailArray = (arr1, arr2) => {
  
    // if the arr1 is the final emails, arr2 is the original email list,
    //     then the remainings of the arr1 are the added by the user.

    // if the arr1 is the original emails, arr2 is the final email list,
    //     then the remainings of the arr1 are the removed by the user.
 
    for (let i = arr1.length - 1; i >= 0; i--) {
        for (let j = 0; j < arr2.length; j++) {
           
            if(arr1[i].email === arr2[j].email){
                arr1.splice(i,1);
                break;
            }
        }
    }
 
    const emails = [];
    for (let index = 0; index < arr1.length; index++) {
        const emailElem = arr1[index];
        emails.push(emailElem.email);
    };
    return emails;
};

const removeBlankEmail = (emailData) => {
    
    for (let index = emailData.length - 1; index >= 0; index--) {
        const element = emailData[index];
        if(element.email === ''){
            emailData.splice(index,1);
       }
    }
};

// Put the focus on the input field. Only one input at any time.
const focusOnInputEmailField = () => {
    
    const inputs = document.querySelectorAll('input');
    
    for (let index = inputs.length - 1 ; index >= 0; index--) {
        const input = inputs[index];
        if(input.id.includes('emailAddress')){
            input.focus();            
            input.addEventListener('keypress', (e) => {
                if(e.key === 'Enter' && getCheckButton() != null){
                    getCheckButton().click();
                }
            });
            break;
        }           
    }
};

// Compare two objects
const objectsEqual = (o1, o2) => {
    return Object.keys(o1).length === Object.keys(o2).length 
       && Object.keys(o1).every(p => o1[p] === o2[p]);
};

// Compare two arrays
const arraysEqual = (a1, a2) => {
    return a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));
};    

// Add the event listener to all the pen buttons.
const addPenEventListener = () => {
    const penIcons = document.querySelectorAll('.fa-pen');    
    for (let index = 0 ; index < penIcons.length ; index++) {
        const penIcon = penIcons[index];
        const penButton = penIcon.closest('button');   
        penButton.addEventListener('click' , (e) => {            
            setTimeout(setCheckCloseButtonClassName, 200);
            setTimeout(focusOnInputEmailField,200);
            setTimeout(addCancelEventListener, 200);
        });
    }
};

// When click Cancel, need to re-add the event listener for pen button.
const addCancelEventListener = () => {
    getCloseButton().addEventListener('click',(e) => {
        setTimeout(addPenEventListener, 200);          
    });
};

const setCheckCloseButtonClassName = () => {
    // Display the check button and highlight it.
    getCheckButton().className =  `myCustomThemeButton__button jut__Button__button jut__Button__primary jut__Button__small jut__Button__materialIcon 
    jut__ActionColumn__actionButton jut__ActionColumn__editButton RIBillingDeliveryComponent_ri__ActionColumn__actionButton__KW0-R`;

    // Display the"X" button but do not highlight it.
    getCloseButton().className = `myCustomThemeButton__button jut__Button__button jut__Button__tertiary jut__Button__small 
    RIBillingDeliveryComponent_ri__ActionColumn__actionButton__KW0-R jut__ActionColumn__actionButton`;  

}

export { getToggleButtonObj, 
         setToggleButtonClassName, 
         buildEmailArray, 
         arraysEqual,
         getCheckButton,
         focusOnInputEmailField,
         clickCheckButton,
         removeBlankEmail,
         addPenEventListener,
         setCheckCloseButtonClassName,
         getCloseButton,
         clickLastTrashButton}
